module.exports = __webpack_public_path__ + "img/banner.bb3179c0.png";